export default {"src":"/_next/static/media/kiosk.04d26113.svg","height":433,"width":433};